import React, { useState, useEffect } from 'react';
import { Button, MenuItem, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigate } from 'react-router-dom';
import { local_url } from '../Const';
import Header from '../Header';
import { useLocation } from 'react-router-dom';
import CompanyList from './CompanyList';



export const AllBranch = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { companyName, companyCode } = location.state || {};
    const [ledgerData, setLedgerData] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [openForm, setOpenForm] = useState(false);
    const [selectedType, setSelectedType] = useState('ST'); // Default value 'ST'

    const [isEditing, setIsEditing] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [formData, setFormData] = useState({
        branchID: "",
        forBranchID: "",
        branchCode: "",
        branchName: "",
        creditLimit: 0,
        creditDays: 0,
        enhancedCreditLimitPC: 0,
        enhancedCreditLimitDays: 0,
        beatID: "",
        branchType: "",
        entityCode: "",
        stateCode: "",
        gstNumber: "",
        rtype: "",
        zoneCode: "",
        createdUserId: "",
        createdDate: "",
        modifiedUserId: "",
        modifiedDate: "",
        deletedUserId: "",
        deletedDate: ""
    });

    const fetchLedgerData = async () => {
        setLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('AuthorizationToken');
            const response = await fetch(`${local_url}/api/Company/GetBranchList/ALL/TYPE/ST`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setLedgerData(data);
        } catch (error) {
            setError("Failed to fetch branch data. Please try again later.");
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = localStorage.getItem('AuthorizationToken');
                const response = await fetch(`${local_url}/api/Company/GetBranchList/ALL/TYPE/${selectedType}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setLedgerData(data);
            } catch (error) {
                setError("Failed to fetch branch data. Please try again later.");
                console.error("API Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
        fetchCompanyList();
    }, [selectedType]); // Add selectedType as a dependency

    useEffect(() => {
        fetchLedgerData();
    }, []);

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleTypeChange = async (event) => {
        const newType = event.target.value;
        setSelectedType(newType);
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('AuthorizationToken');
            const response = await fetch(`${local_url}/api/Company/GetBranchList/ALL/TYPE/${newType}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setLedgerData(data);
        } catch (error) {
            setError("Failed to fetch branch data. Please try again later.");
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenForm = () => {
        setIsEditing(false);
        setFormData({
            branchID: "",
            forBranchID: "",
            branchCode: "",
            branchName: "",
            creditLimit: 0,
            creditDays: 0,
            enhancedCreditLimitPC: 0,
            enhancedCreditLimitDays: 0,
            beatID: "",
            branchType: "",
            entityCode: "",
            stateCode: "",
            gstNumber: "",
            rtype: "",
            zoneCode: "",
            createdUserId: "",
            createdDate: "",
            modifiedUserId: "",
            modifiedDate: "",
            deletedUserId: "",
            deletedDate: ""
        });
        setOpenForm(true);
    };

    const handleEdit = (rowData, index) => {
        setIsEditing(true);
        setSelectedRowIndex(index);
        setFormData(rowData); // Populate form with existing branch data
        setOpenForm(true); // Open form for editing
    };


    const handleCloseForm = () => {
        setOpenForm(false);
        setIsEditing(false);
        setSelectedRowIndex(null);
    };

    const handleSaveForm = async () => {
        try {
            const token = localStorage.getItem('AuthorizationToken');
            const url = `${local_url}/api/Company/UpdateBranch`; // Use the UpdateBranch API

            const response = await fetch(url, {
                method: 'POST', // Change method to PUT for update
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Re-fetch the ledger data after the update
            await fetchLedgerData();
            handleCloseForm();
        } catch (error) {
            setError("Failed to update branch data. Please try again later.");
            console.error("API Error:", error);
        }
    };




    const fetchCompanyList = async () => {
        try {
            const token = localStorage.getItem('AuthorizationToken');
            const response = await fetch(`${local_url}/api/Company/GetCompanyList`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setCompanyList(data);
        } catch (error) {
            setError("Failed to fetch company list. Please try again later.");
            console.error("API Error:", error);
        }
    };

    useEffect(() => {
        fetchLedgerData();
        fetchCompanyList();
    }, []);


    return (
        <div className="reports-root">
            <Header />
            <div className="reports-container">

                <div className="reports-header">

                    <h1 className="reports-title">Branch List</h1>
                    <FormControl variant="outlined" size="small" style={{ minWidth: 200, marginLeft: 20 }}>
                        <InputLabel>Branch Type</InputLabel>
                        <Select
                            value={selectedType}
                            onChange={handleTypeChange}
                            label="Branch Type"
                        >
                            <MenuItem value="ST">On Branch</MenuItem>
                            <MenuItem value="CS">Customer</MenuItem>
                            <MenuItem value="LV">Local Vendor</MenuItem>

                        </Select>
                    </FormControl>
                    {/* <Button
              variant="contained"
              color="primary"
              onClick={handleOpenForm}
              startIcon={<AddIcon />}
              style={{ marginTop: '20px' }}
            >
              Add Branch
            </Button> */}
                </div>

                {error && (
                    <div className="reports-error">
                        <span className="reports-error-text">{error}</span>
                    </div>
                )}

                <div className="reports-table-wrapper">

                    <div className="reports-table-container">
                        <table className="reports-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Branch ID</th>
                                    <th>For Branch ID</th>
                                    <th>Branch Code</th>
                                    <th>Branch Name</th>
                                    <th>Branch Type</th>
                                    <th>Entity Code</th>
                                    <th>State Code</th>
                                    <th>GST Number</th>
                                    <th>Zone Code</th>
                                    <th>Credit Limit</th>
                                    <th>Credit Days</th>
                                    <th>Enhanced Credit Limit PC</th>
                                    <th>Enhanced Credit Limit Days</th>
                                    <th>Beat ID</th>
                                    <th>RType</th>
                                    <th>Created Date</th>
                                    <th>Modified Date</th>
                                    <th className="sticky-column">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="19" className="reports-loading">
                                            <CircularProgress size={40} />
                                        </td>
                                    </tr>
                                ) : ledgerData.length > 0 ? (
                                    ledgerData.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                            <td>{item.branchID || "-"}</td>
                                            <td>{item.forBranchID || "-"}</td>
                                            <td>{item.branchCode || "-"}</td>
                                            <td>{item.branchName || "-"}</td>
                                            <td>{item.branchType || "-"}</td>
                                            <td>{item.entityCode || "-"}</td>
                                            <td>{item.stateCode || "-"}</td>
                                            <td>{item.gstNumber || "-"}</td>
                                            <td>{item.zoneCode || "-"}</td>
                                            <td>{item.creditLimit || "-"}</td>
                                            <td>{item.creditDays || "-"}</td>
                                            <td>{item.enhancedCreditLimitPC || "-"}</td>
                                            <td>{item.enhancedCreditLimitDays || "-"}</td>
                                            <td>{item.beatID || "-"}</td>
                                            <td>{item.rtype || "-"}</td>
                                            <td>{new Date(item.createdDate).toLocaleDateString() || "-"}</td>
                                            <td>{new Date(item.modifiedDate).toLocaleDateString() || "-"}</td>
                                            <td className="sticky-column reports-actions">
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() => handleEdit(item, index)}
                                                >
                                                    Edit
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="19" className="reports-no-data">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <Dialog open={openForm} onClose={handleCloseForm} maxWidth="md" fullWidth>
                    <DialogTitle>{isEditing ? 'Edit Branch' : 'Add New Branch'}</DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', padding: '16px' }}>
                            <TextField
                                label="Branch ID"
                                variant="outlined"
                                name="branchID"
                                value={formData.branchID}
                                onChange={handleFormChange}
                                disabled
                                fullWidth
                            />
                            <TextField
                                label="For Branch ID"
                                variant="outlined"
                                name="forBranchID"
                                value={formData.forBranchID}
                                onChange={handleFormChange}
                                fullWidth
                                disabled
                            />
                            <TextField
                                label="Branch Code"
                                variant="outlined"
                                name="branchCode"
                                value={formData.branchCode}
                                onChange={handleFormChange}
                                fullWidth
                                disabled
                            />
                            <TextField
                                label="Branch Name"
                                variant="outlined"
                                name="branchName"
                                value={formData.branchName}
                                onChange={handleFormChange}
                                fullWidth
                                disabled
                            />
                            
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Branch Type</InputLabel>
                                <Select
                                    value={formData.branchType}
                                    onChange={(e) => handleFormChange({ target: { name: "branchType", value: e.target.value } })}
                                    label="Branch Type"
                                    name="branchType"
                                >
                                    <MenuItem value="ST">On Branch</MenuItem>
                                    <MenuItem value="CS">Customer</MenuItem>
                                    <MenuItem value="LV">Local Vendor</MenuItem>

                                </Select>
                            </FormControl>
                           
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>RType</InputLabel>
                                <Select
                                    value={formData.rtype}
                                    onChange={(e) => handleFormChange({ target: { name: "rtype", value: e.target.value } })}
                                    label="RType"
                                    name="rtype"
                                >
                                    <MenuItem value="LAZIZ">LAZIZ</MenuItem>
                                    <MenuItem value="RETil">Retail</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Company Code</InputLabel>
                                <Select
                                    name="entityCode"
                                    value={formData.entityCode}
                                    onChange={handleFormChange}
                                    label="Company Code"
                                >
                                    {companyList.map((company) => (
                                        <MenuItem key={company.entityCode} value={company.entityCode}>
                                            {company.entityName} ({company.entityCode})
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth variant="outlined">
                                <InputLabel>State Code</InputLabel>
                                <Select
                                    value={formData.stateCode}
                                    onChange={(e) => handleFormChange({ target: { name: "stateCode", value: e.target.value } })}
                                    label="State Code"
                                    name="stateCode"
                                >
                                    <MenuItem value="INMH">MAHARASTRA</MenuItem>
                                    <MenuItem value="INCT">CHHATTISGARH</MenuItem>

                                </Select>
                            </FormControl>
                            <TextField
                                label="GST Number"
                                variant="outlined"
                                name="gstNumber"
                                value={formData.gstNumber}
                                onChange={handleFormChange}
                                fullWidth
                            />
                            {/* <TextField
                                label="Zone Code"
                                variant="outlined"
                                name="zoneCode"
                                value={formData.zoneCode}
                                onChange={handleFormChange}
                                fullWidth
                            /> */}
                            <TextField
                                label="Credit Limit"
                                variant="outlined"
                                name="creditLimit"
                                type="number"
                                value={formData.creditLimit}
                                onChange={handleFormChange}
                                fullWidth
                            />
                            <TextField
                                label="Credit Days"
                                variant="outlined"
                                name="creditDays"
                                type="number"
                                value={formData.creditDays}
                                onChange={handleFormChange}
                                fullWidth
                            />
                            <TextField
                                label="Enhanced Credit Limit PC"
                                variant="outlined"
                                name="enhancedCreditLimitPC"
                                type="number"
                                value={formData.enhancedCreditLimitPC}
                                onChange={handleFormChange}
                                fullWidth
                            />
                            <TextField
                                label="Enhanced Credit Limit Days"
                                variant="outlined"
                                name="enhancedCreditLimitDays"
                                type="number"
                                value={formData.enhancedCreditLimitDays}
                                onChange={handleFormChange}
                                fullWidth
                            />
                            <TextField
                                label="Beat ID"
                                variant="outlined"
                                name="beatID"
                                value={formData.beatID}
                                onChange={handleFormChange}
                                fullWidth
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseForm} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={handleSaveForm} color="primary" variant="contained">
                            {isEditing ? 'Update' : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>




            <style jsx>{`
            .reports-root {
              min-height: 100vh;
              background-color: #f5f7fa;
            }
  
            .reports-container {
              padding: 1rem;
              max-width: 1440px;
              margin: 0 auto;
            }
  
            .reports-header {
              display: flex;
              justify-content: space-around;
              align-items: center;
              margin-bottom: 2rem;
            }
  
            .reports-title {
              font-size: 1.75rem;
              font-weight: 600;
              color: #1a1a1a;
              margin: 0;
            }
  
            .dropdown-and-button {
              display: flex;
              align-items: center;
            }
  
            .reports-error {
              background-color: #fee2e2;
              border: 1px solid #ef4444;
              border-radius: 8px;
              padding: 1rem;
              margin-bottom: 1.5rem;
            }
  
            .reports-error-text {
              color: #dc2626;
              font-size: 0.875rem;
              font-weight: 500;
            }
  
            .reports-table-wrapper {
              background-color: white;
              border-radius: 12px;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
                          0 2px 4px -1px rgba(0, 0, 0, 0.06);
              overflow: hidden;
            }
  
            .reports-table-container {
              overflow-x: auto;
              position: relative;
            }
  
            .reports-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
              font-size: 0.875rem;
            }
  
            .reports-table th {
              background-color: #f8f9fa;
              color: #4b5563;
              font-weight: 600;
              text-align: left;
              padding: 1rem;
              border-bottom: 2px solid #e5e7eb;
              white-space: nowrap;
            }
  
            .reports-table td {
              padding: 1rem;
              border-bottom: 1px solid #e5e7eb;
              color: #374151;
            }
  
            .reports-table tbody tr:hover {
              background-color: #f9fafb;
            }
  
            .sticky-column {
              position: sticky !important;
              right: 0;
              background-color: white !important;
              z-index: 20;
              box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
            }
  
            .reports-table tbody tr:hover .sticky-column {
              background-color: #f9fafb !important;
            }
  
            .reports-table th.sticky-column {
              background-color: #f8f9fa !important;
              z-index: 21;
            }
  
            .reports-actions {
              white-space: nowrap;
              text-align: center;
              min-width: 100px;
              padding: 0.5rem !important;
            }
  
            .reports-loading {
              text-align: center;
              padding: 3rem !important;
          }

          .reports-no-data {
            text-align: center;
            color: #6b7280;
            font-style: italic;
            padding: 2rem !important;
          }

          .form-row {
            display: flex;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .form-row .MuiTextField-root {
            flex: 1;
          }

          @media (max-width: 1024px) {
            .reports-container {
              padding: 0.5rem;
            }

            .reports-header {
              flex-direction: column;
              gap: 1rem;
            }

            .reports-title {
              font-size: 1.5rem;
              text-align: center;
            }

            .form-row {
              flex-direction: column;
              gap: 0;
            }
          }

          @media (max-width: 768px) {
            .reports-table-container {
              font-size: 0.75rem;
            }

            .reports-table th,
            .reports-table td {
              padding: 0.75rem;
            }
          }
        `}</style>
        </div>
    );
};

export default AllBranch;
